import React from 'react';
import { SingleSelectionView } from './single-selection';

export const RatingView = props => (
  <SingleSelectionView {...props} rootClassName="rating" />
);
